import { Grid, Tab, Tabs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { usePolicyInfoContext } from '../contexts/policyInfoContext';

export const PolicyTabs = () => {
  const {
    tabs,
    selectedTab,
    handleSelectTab
  } = usePolicyInfoContext();

  return (
    <Grid container direction="column">
      <Grid item xs={12}>
        <Grid container direction="row" spacing={2}>
          <Tabs value={selectedTab?.id} textColor="primary">
            {tabs.map(tab => (
              <Tab
                key={tab.id}
                value={tab.id}
                label={<Typography style={{ textTransform: "none", color: tab.id === selectedTab?.id ? "#FB8C00" : "gray" }}>{tab.description}</Typography>}
                onClick={() => handleSelectTab(tab)}
              />
            ))}
          </Tabs>
        </Grid>
      </Grid>
    </Grid>
  );
};
